import React from 'react';
import CompanySearch from './CompanySearch'
import {
    useHistory
  } from "react-router-dom";
  
  function TopNav()  {

    let history = useHistory();

    function onSubmit()
    {
      history.push("/find");
    }

    return <div className="row"><div className="col">
            <header className="top-header">
                <div className="float-right"><img className="float-right" src="locallygives-logo-sm.png" className="topnav-logo" alt="logo" /></div>
            </header>
        </div>
        </div>
    ;
  }

  export default TopNav;


